import React, { useEffect } from 'react'

import { useParams, useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { Box, Button } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import {
  PrivacyByDesignForm,
  PrivacyByDesignQuestionReply,
  PrivacyByDesignReviewActions,
  PrivacyByDesignReviewPanel,
} from './components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'
import { routes } from 'Routes'
import schema from './components/PrivacyByDesignForm/schema'
import { buildDefaultValues } from './components/PrivacyByDesignForm/formMappers'

const PrivacyByDesignShow = () => {
  const history = useHistory()
  const params = useParams()

  const privacyByDesignId = params.privacyByDesignId

  const { PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1 } = constants.privacyByDesign

  const {
    response,
    isLoading: isLoadingPrivacyByDesign,
    refresh,
  } = useFetch(service.dponet.privacyByDesign.get, {
    privacyByDesignId,
  })

  const privacyByDesign = response?.data?.privacyByDesign

  const formMethods = useForm({
    validationSchema: schema({ mode: 'show' }),
    defaultValues: buildDefaultValues(privacyByDesign, { mode: 'show' }),
  })

  const { reset } = formMethods

  // Cada questão monta o próprio formulário a partir da resposta já salva.
  useEffect(() => {
    if (privacyByDesign) {
      reset(buildDefaultValues(privacyByDesign, { mode: 'show' }))
    }
  }, [privacyByDesign, reset])

  return (
    <Page title="Visualização de Projeto - Privacy By Design">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoadingPrivacyByDesign} />
        <ContentHeader title="Privacy By Design" />
        <FormContext {...formMethods}>
          {privacyByDesign && (
            <PrivacyByDesignForm
              mode="show"
              privacyByDesign={privacyByDesign}
              cardId={PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1}
            />
          )}
          <PrivacyByDesignReviewPanel
            privacyByDesign={privacyByDesign}
            actions={
              <PrivacyByDesignReviewActions
                privacyByDesign={privacyByDesign}
                service={service.dponet.privacyByDesign}
                refresh={refresh}
                // Reabrir devolve o projeto para pendente: a tela seguinte é a
                // edição, onde as questões são respondidas e enviadas.
                onReopen={() =>
                  history.push(
                    reverse(routes.privacyByDesign.edit, { privacyByDesignId }),
                  )
                }
              />
            }
          />
          <PrivacyByDesignQuestionReply
            questions={privacyByDesign?.questions}
            isLoading={isLoadingPrivacyByDesign}
            isShow
          />
        </FormContext>
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.privacyByDesign.all)}
            >
              Voltar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default PrivacyByDesignShow
